import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=5d5b4cbd"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports